import {
    createStore as reduxCreateStore,
    combineReducers,
    applyMiddleware
} from 'redux';
import { createLogger } from 'redux-logger'
import thunk from 'redux-thunk';
import { routerMiddleware, connectRouter } from 'connected-react-router'

// Import reducers
import {QuestionReducer} from '../Question/reducers';
import {UserReducer} from '../User/reducers';
import {UsersReducer} from '../Users/reducers';
import {HomeReducer} from '../Home/reducers';
import {DetailReducer} from "../Detail/reducers";

// createStoreの再定義 - historyを引数で受け、connected-react-routerの利用を抽象化
export default function createStore(history) {

    // Define individual settings of redux-logger
    let middleWares = [routerMiddleware(history), thunk];
    if (process.env.REACT_APP_PROJECT_ID !== 'nitaku-prod') {
        const logger = createLogger({
            collapsed: true,
            diff: true
        });
        middleWares.push(logger)
    }

    return reduxCreateStore( // オリジナル createStore の別名
        combineReducers({
            detail: DetailReducer,
            post: QuestionReducer,
            questions: HomeReducer,
            router: connectRouter(history),
            user: UserReducer,
            users: UsersReducer,
        }),
        applyMiddleware(
            ...middleWares
        )
    );
}